import React from 'react';
import classnames from 'classnames';
import * as styles from './base.scss';
import Icon from 'Shared/Icon';
export default class Item extends React.Component {
    render() {
        const isOpen = this.props.open === this;
        return (React.createElement("div", null,
            React.createElement("div", { className: classnames(styles.headerContainer, { [styles.active]: isOpen }) },
                React.createElement("button", { className: classnames(styles.header, { [styles.active]: isOpen }), onClick: () => this.props.toggle(this), tabIndex: this.props.tabindex },
                    React.createElement("span", null, this.props.label),
                    React.createElement(Icon, { name: isOpen ? 'arrow-up' : 'arrow-down' }))),
            React.createElement("div", { className: styles.itemContainer }, isOpen && this.props.children)));
    }
}
